import { render, staticRenderFns } from "./EdenLoader.vue?vue&type=template&id=edc36bec&scoped=true"
import script from "./EdenLoader.vue?vue&type=script&lang=js"
export * from "./EdenLoader.vue?vue&type=script&lang=js"
import style0 from "./EdenLoader.vue?vue&type=style&index=0&id=edc36bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc36bec",
  null
  
)

export default component.exports